(function(angular) {
    'use strict';

    /*
    Creates a new sub-module to be used for error pages
    */
    var app = angular.module('enervee.errorPages', []);

    /*
        Creates a new controller for the error pages called "ErrorPagesCtrl"
    */
    app.controller('ErrorPagesCtrl', [
        '$scope',
        'CmsContentService',
        'NavLinksService',
        function(
            $scope,
            CmsContentService,
            NavLinksService
        ) {
            $scope.faqLink = NavLinksService.getErrorPageFAQLink();

            CmsContentService.getMarketPlaceText(
                'error_page:check_faq_text',
                {
                    'faq_link': '<a ng-click="handleFAQLinkClick($event, faqTrackingParams)" href="' + $scope.faqLink + '">FAQ</a>'
                }
            ).then(function(text) {
                $scope.checkFAQText = text;
            });

            $scope.faqTrackingParams = {
                attributes: {
                    pageSection: 'Main',
                },
            };
            $scope.handleFAQLinkClick = NavLinksService.handleFAQLinkClick;
        }
    ]);

})(angular);
